<template>
    <button @click.prevent="openModal" :disabled="disabled"><span v-html="cta"></span></button>
</template>

<script>
export default {
    props: {
        eventId: {
            type: Number,
            required: true,
        },
        cta: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },

    methods: {
        openModal() {
            this.$root.trainingEnrollmentVisible = true
            this.$root.trainingEnrollmentId = this.eventId
        }
    }
}
</script>